import callApiAxiosClient from '../../axios/axios_client';

function addCategoryPicture(picture: Blob): Promise<string> {
  const token = JSON.parse(localStorage.getItem('user')!);
  const authorization = 'Bearer ' + token.token;
  return callApiAxiosClient<string>({
    method: 'post',
    url: 'categories/save-temporary-file',
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: authorization,
    },
    data: {
      image: picture,
    },
  });
}
export default addCategoryPicture;
